export const GENERAL_ERROR_MSG =
  'Something went wrong. Please refresh the page and try again.';
export const REDIRECT_ERROR_MSG =
  "We're redirecting you to sign in to your account.";
export const TECHNICAL_ERROR_MSG =
  "We're sorry. There was a temporary technical error. Please try again later.";
/* Shown to a customer who reached ID.me's consent screen and declined to share
/* their information with The Home Depot. Deliberately not phrased as a failure:
/* declining is a choice the customer made, the discount is still theirs to
/* claim, and the only thing standing between them and it is the one button this
/* copy names. */
export const IDME_ACCESS_DENIED_HEADLINE = 'Information Sharing Required';
export const IDME_ACCESS_DENIED_MSG =
  'Information sharing is required to receive your military discount. ' +
  'Select "Verify with ID.me" below to sign in and allow sharing.';
export const IDME_ERROR_HEADLINE = 'Something went wrong';
export const IDME_ERROR_MSG =
  'Refresh the page to verify your military affiliation with ID.me.';
export const IDME_INELIGIBLE_HEADLINE = 'Verification incomplete';
/* The rest of this message carries a link, so it lives as JSX in
/* components/IdmeVerification/IneligibilityMessage.jsx rather than here. */
export const IDME_INELIGIBLE_LINK_LABEL = 'FAQ';
export const IDME_SUCCESS_MSG = 'Verification successful';
